module.exports = {
  detail: {
    coderror: '200',
    desc_coderror: ' ',
    httpcode: '',
    flg: '',
    codcompy: 'TJS',
    desc_compy: 'บริษัท พีเพิล พลัส ซอฟต์แวร์ จำกัด',
    codlinef: '0001',
    desc_linef: '0001 Organization chart TJS',
    dteeffec: '07/08/2017',
    dteuse: '02/08/2017',
    codappr: '16010',
    desc_appr: 'นายสมชาย วิชัย',
    remark: 'Test By S'
  },
  table: {
    total: 5,
    rows: [
      {
        coderror: '200',
        desc_coderror: ' ',
        httpcode: ' ',
        flg: ' ',
        total: 5,
        rcnt: 1,
        orgid: '2',
        parentorgid: '1',
        numseq: '1',
        codcompn: '100',
        codcomp: 'TJS100',
        desc_codcomp: 'ฝ่ายดำเนินการและพัฒนาระบบ',
        codpospr: '0720',
        desc_codpos: 'Technical Consult',
        codsupvi: '',
        desc_supvi: '   ',
        imgsupvi: '',
        assist: [],
        qty_subordi: '0',
        complvl: '2'
      },
      {
        coderror: '200',
        desc_coderror: ' ',
        httpcode: ' ',
        flg: ' ',
        total: 5,
        rcnt: 2,
        orgid: '3',
        parentorgid: '1',
        numseq: '1',
        codcompn: '200',
        codcomp: 'TJS200',
        desc_codcomp: 'ฝ่ายขายและการตลาด',
        codpospr: '0740',
        desc_codpos: 'Customer Support',
        codsupvi: '',
        desc_supvi: '   ',
        imgsupvi: '',
        assist: [],
        qty_subordi: '0',
        complvl: '2'
      },
      {
        coderror: '200',
        desc_coderror: ' ',
        httpcode: ' ',
        flg: ' ',
        total: 5,
        rcnt: 3,
        orgid: '4',
        parentorgid: '1',
        numseq: '1',
        codcompn: '300',
        codcomp: 'TJS300',
        desc_codcomp: 'ฝ่ายบัญชีการเงินและทรัพยากรบุคคล',
        codpospr: '0740',
        desc_codpos: 'Customer Support',
        codsupvi: '',
        desc_supvi: '   ',
        imgsupvi: '',
        assist: [],
        qty_subordi: '0',
        complvl: '2'
      },
      {
        coderror: '200',
        desc_coderror: ' ',
        httpcode: ' ',
        flg: ' ',
        total: 5,
        rcnt: 4,
        orgid: '1',
        parentorgid: '',
        numseq: '1',
        codcompn: 'TJS',
        codcomp: 'TJS',
        desc_codcomp: 'บริษัท พีเพิล พลัส ซอฟต์แวร์ จำกัด',
        codpospr: '0110',
        desc_codpos: 'Advisor-Onk-Edited',
        codsupvi: '33054',
        desc_supvi: 'นางสมพิศ  สัมฤทธ์',
        imgsupvi: '33054.jpg',
        assist: [],
        qty_subordi: '0',
        complvl: '1'
      },
      {
        coderror: '200',
        desc_coderror: ' ',
        httpcode: ' ',
        flg: ' ',
        total: 5,
        rcnt: 5,
        orgid: '8',
        parentorgid: '2',
        numseq: '8',
        codcompn: '900',
        codcomp: 'TJS100900',
        desc_codcomp: '*********************************************',
        codpospr: '0740',
        desc_codpos: 'Customer Support',
        codsupvi: '32007',
        desc_supvi: 'นายสนธยา  วิโรจน์',
        imgsupvi: '32007.jpg',
        assist: [],
        qty_subordi: '0',
        complvl: '3'
      },
      {
        coderror: '200',
        desc_coderror: ' ',
        httpcode: ' ',
        flg: ' ',
        total: 5,
        rcnt: 5,
        orgid: '9',
        parentorgid: '8',
        numseq: '9',
        codcompn: '100',
        codcomp: 'TJS100900100',
        desc_codcomp: '*********************************************',
        codpospr: '0740',
        desc_codpos: 'Customer Support',
        codsupvi: '32007',
        desc_supvi: 'นายสนธยา  วิโรจน์',
        imgsupvi: '32007.jpg',
        assist: [],
        qty_subordi: '0',
        complvl: '4'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/api/hres4ax/mockDetail.js